module.exports = __webpack_public_path__ + "bc45c4f364aed238f86721010c3ee608.png";